<template>
	<div>
		<div v-if="!showOrderProcess">

			<div v-if="subscriptionIsUpgradeable">
				<PricingBoxes ref="pricingBoxes" v-on:selection="startUpgrade"></PricingBoxes>
			</div>
			<div v-if="fullMode" class="order-view subscription-status">
				<template v-if="!subscriptionIsUpgradeable">
					<h2>{{ $t('subscriptionmanager.subscription.headline') }}</h2>
					<div class="seperator"></div>
					<ul>
						<li>
							<p class="name">{{ $t('subscriptionmanager.current.subscription') }}</p>
							<p class="info">{{ getSubscriptionName }}</p>
						</li>
						<li>
							<p class="name">{{ $t('subscriptionmanager.current.status') }}</p>
							<p class="info">{{ getSubscriptionStatus }}</p>
						</li>
					</ul>
				</template>
				<template v-if="true">
					<div v-if="subscriptionIsCancellale">
						<button class="purple" v-on:click="unsubscribe" v-if="!subscriptionIsCancelled" :disabled="unsubscribing">
							<span v-if="!unsubscribing">{{ $t('subscriptionmanager.cancel.button') }}</span>
							<span v-if="unsubscribing">{{ $t('pleasewait') }}</span>
						</button>
						<button class="purple" v-else v-on:click="regretCancellation" :disabled="unsubscribing">
							<span v-if="!unsubscribing">{{ $t('subscriptionmanager.regretcancellation.button') }}</span>
							<span v-if="unsubscribing">{{ $t('pleasewait') }}</span>
						</button>
					</div>
				</template>
			</div>
		</div>
		<div v-if="showOrderProcess">
			<OrderProcess :product="upgradeToId" v-on:completed="completed()">

			</OrderProcess>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

    import {mapGetters} from 'vuex';
    import PricingBoxes from '../views/PricingBoxes';
    import OrderProcess from './OrderProcess.vue';

	export default {
		data: () => ({
			upgrading: false,
			unsubscribing: false,
			showOrderProcess: false,
			planId: 4
		}),
		props: ['mode', 'plan'],
		components: {
			PricingBoxes,
			OrderProcess
		},
		computed: {
			...mapGetters([
				'getToken',
				'getSubscriptionName',
				'subscriptionIsUpgradeable',
				'subscriptionIsCancellale',
				'subscriptionIsCancelled',
				'subscriptionExpirationDate',
			]),
			upgradeToId() {
				return this.$refs.pricingBoxes.getSelection();
				// return this.annualBilling ? 4 : 3;
			},
			fullMode() {
				return this.mode == 'full';
			},
			getSubscriptionStatus() {
				if (this.subscriptionExpirationDate) {
					return this.$t('subscription-status.expires-on.label') + ' ' + this.subscriptionExpirationDate;
				} else {
					return this.$t('subscription-status.active.label');
				}
			},
		},
		methods: {
			completed() {
				this.$router.go(0);
			},
			startUpgrade() {
				let planId = this.$refs.pricingBoxes.getSelection();
				this.planId = planId;
				if (this.planId == 2) {
					this.$router.push('/');
				} else {
					this.showOrderProcess = true;
				}
			},
			regretCancellation() {
				var self = this;
				this.unsubscribing = true;
				axios({
					method: 'POST',
					url: window.config.apiUrl + 'api/user/subscription/regret-cancellation',
					cancelToken: window.AuthorizationCancelSource.token,
				}).then(response => {
					self.$store.dispatch('fetchUserSubscription');
				}).finally((e) => {
					self.unsubscribing = false;
		        });
			},
			unsubscribe() {
				if (!confirm(this.$t('subscriptionmanager.confirm-cancellation.label'))) {
					return;
				}
				var self = this;
				this.unsubscribing = true;
				axios({
					method: 'DELETE',
					url: window.config.apiUrl + 'api/user/subscription',
					cancelToken: window.AuthorizationCancelSource.token,
				}).then(response => {
					self.$store.dispatch('fetchUserSubscription');
				}).finally((e) => {
					self.unsubscribing = false;
		        });
			},
		},
		mounted() {
			this.$store.dispatch('fetchUserSubscription');
			if (this.plan) {
				this.planId = this.plan;
			}
		}
	}
</script>
